/* eslint-disable consistent-return */
import { InteractionRequiredAuthError, PublicClientApplication } from '@azure/msal-browser';
import { loadUserProfileDone, userInitialState } from 'core/store/stores';

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_MSAL_CLIENT_ID,
    authority: process.env.REACT_APP_MSAL_AUTHORITY,
    knownAuthorities: [process.env.REACT_APP_MSAL_KNOWNAUTHORITY],
    redirectUri: process.env.REACT_APP_MSAL_REDIRECT_URI,
    postLogoutRedirectUri: process.env.REACT_APP_MSAL_LOGIN_REDIRECT_URI,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: true,
  },
};

export const loginRequest = {
  scopes: ['openid', process.env.REACT_APP_SCOPE_DOMAIN],
  authority: process.env.REACT_APP_MSAL_AUTHORITY,
};

export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
};

export const msalInstance = new PublicClientApplication(msalConfig);

const isTokenValid = token => {
  const payload = JSON.parse(atob(token.split('.')[1]));
  const expiry = payload.exp * 1000;
  const now = new Date().getTime();
  return now < expiry;
};

export const acquireToken = async () => {
  const accounts = msalInstance.getAllAccounts();
  const storedToken = sessionStorage.getItem('msalToken');

  if (storedToken && isTokenValid(storedToken)) {
    return storedToken;
  }

  if (accounts.length === 0) {
    await msalInstance.loginRedirect(loginRequest);
  } else {
    const silentRequest = {
      scopes: loginRequest.scopes,
      account: accounts[0],
    };

    return msalInstance
      .acquireTokenSilent(silentRequest)
      .then(response => {
        sessionStorage.setItem('msalToken', response.idToken);
        return response.idToken;
      })
      .catch(error => {
        if (error instanceof InteractionRequiredAuthError) {
          return msalInstance.acquireTokenRedirect(silentRequest);
        }
        console.error(error);
      });
  }
};

export const logout = async () => {
  localStorage.removeItem('log');
  localStorage.removeItem('i18nextLng');
  localStorage.removeItem('theme_recomendador');
  sessionStorage.removeItem('msalToken');
  loadUserProfileDone(userInitialState);
  return msalInstance.logoutRedirect();
};
